import {
  newFiltersData,
  IFiltersData,
} from '../../shopListingBottomSheet/utils/index';
import {useLabListingFilters} from '../../../../hooks/filters/useLabListingFilter';

const FiltersLabList = () => {
  const {labListingFilters, resetFilterLabListing, setFilterLabListing} =
    useLabListingFilters();

  return (
    <div className="flex gap-2 items-center">
      <div className="flex gap-2 items-center">
        {labListingFilters.input_guid?.map(item => (
          <div
            className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap"
            key={item.guid}
          >
            {item.title}
            <i
              className="mr-3 text-lg icon-nameClose-remove"
              onClick={() =>
                setFilterLabListing(
                  'input_guid',
                  labListingFilters.input_guid.filter(
                    g => g.guid !== item.guid,
                  ),
                )
              }
            />
          </div>
        ))}
      </div>
      {labListingFilters?.order_by && (
        <div className="flex items-center border-[1px] text-sm text-farm-shop-600 rounded-full bg-farm-shop-100 w-fit py-2 px-2 whitespace-nowrap">
          <i
            className="text-lg icon-nameClose-remove"
            onClick={() => resetFilterLabListing('order_by')}
          />
          <span>
            {
              newFiltersData?.find(
                (item: IFiltersData) =>
                  item.value === labListingFilters?.order_by,
              )?.title
            }
          </span>
        </div>
      )}
    </div>
  );
};

export default FiltersLabList;
